import { ArrowUp } from "@phosphor-icons/react"
import { Button } from "@tokenterminal/core/ui/button/Button"
import { useEffect, useState } from "react"

export default function ScrollToTopButton() {
  const [showBackToTop, setShowBackToTop] = useState(false)

  useEffect(() => {
    const handleScroll = () => {
      const scrollY = window.scrollY
      setShowBackToTop(scrollY > 400)
    }

    window.addEventListener("scroll", handleScroll)
    return () => window.removeEventListener("scroll", handleScroll)
  }, [])

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" })
  }

  if (!showBackToTop) {
    return null
  }

  return (
    <Button
      onPress={scrollToTop}
      className="fixed bottom-8 right-8 !rounded-full w-12 h-12 flex items-center justify-center z-[1000] p-0"
    >
      <ArrowUp size={24} />
    </Button>
  )
}
